import React from "react";
import lodash from "lodash";
import axios from "axios";
import PropTypes from "prop-types";
import AsyncSelect from "react-select/lib/Async";
import ReactSelect from "react-select";
import classnames from "classnames";

const buildDataResult = data =>
  data.map(item => {
    const label = item.full_name ? item.full_name : item.name;

    return {
      value: item.id.toString(),
      label: label
    };
  });

class FormSelect extends React.Component {
  async componentDidUpdate(prevProps) {
    // if URLchanged (e.g due to location change), refresh options
    if (prevProps.urlSearch !== this.props.urlSearch && this.asyncRef) {
      this.asyncRef.cache = {};

      const defaultOptions = await this.loadOptions("");
      this.asyncRef.setState({ defaultOptions });
    }
  }

  render() {
    const {
      pref,
      _key,
      _val,
      label,
      dataValue,
      errors,
      name,
      value,
      required,
      skipSelect,
      options,
      selectProps,
      urlSearch,
      onChange,
      selectId
    } = this.props;

    const _options = options.map(item => ({
      value: item[_key].toString(),
      label: item[_val]
    }));

    const _value =
      dataValue ||
      lodash.find(_options, { value: value ? value.toString() : "" });

    return (
      <div
        className={classnames("form-group", {
          "has-error": errors && errors.length > 0
        })}
      >
        {label ? (
          <label
            className="control-label word-wrap"
            htmlFor={`select${name}${pref}`}
          >
            {label}
            {required ? " *" : ""}
          </label>
        ) : null}

        {urlSearch ? (
          <AsyncSelect
            {...selectProps}
            ref={ref => (this.asyncRef = ref)}
            inputId={selectId}
            cacheOptions
            className="custom-react-select"
            value={_value || null}
            defaultOptions={_options}
            loadOptions={this.loadOptions}
            onChange={this.handleChange}
            styles={this.props.styles || {}}
            menuPortalTarget={this.props.menuPortalTarget || null}
          />
        ) : (
          <select
            id={`select${name}${pref}`}
            title="Select"
            className="form-control"
            name={name}
            value={value}
            onChange={onChange}
          >
            {skipSelect ? null : (
              <option selected={value === "--"} value="--" disabled>
                Select...
              </option>
            )}
            {options.map(item => (
              <option key={item[_key]} value={item[_key]}>
                {item[_val]}
              </option>
            ))}
          </select>
        )}

        {errors ? (
          <span className="help-block">{errors.join(", ")}</span>
        ) : null}
      </div>
    );
  }

  handleChange = data => {
    const { name, onChange } = this.props;

    if (Array.isArray(data)) {
      onChange(data);
    } else {
      onChange({ target: { value: data.value, name: name } });
    }
  };

  loadOptions = inputValue => {
    const { urlSearch } = this.props;

    const url = urlSearch.replace("{q}", encodeURIComponent(inputValue));
    return axios.get(url).then(resp => buildDataResult(resp.data));
  };
}

FormSelect.propType = {
  selectProps: PropTypes.object,
  pref: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  errors: PropTypes.array,
  dataValue: PropTypes.array,
  value: PropTypes.string,
  options: PropTypes.array,
  required: PropTypes.bool,
  skipSelect: PropTypes.bool,
  urlSearch: PropTypes.string,
  onChange: PropTypes.func
};

FormSelect.defaultProps = {
  selectProps: {},
  required: false,
  urlSearch: null,
  skipSelect: false
};

export default FormSelect;
